<ion-item lines="none" class="clearBoth transparent">
  <div [ngStyle]="{'border-bottom': border, 'margin-top': margin, 'margin-bottom': margin}" [ngClass]="{'buttonRight': !btnLeft, 'clearKeysline': hasClearKeys}">
    <span *ngIf="!isDisabled && hasClearKeys" class="button" (click)="triggerClear()">
      <ion-icon class="icon" name="close-outline"></ion-icon>
    </span>
  </div>
</ion-item>
